var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7359 8.22944C13.5667 8.08253 13.3373 8 13.098 8C12.8588 8 12.6294 8.08253 12.4602 8.22944L7.99455 12.1085L3.52889 8.22944C3.35874 8.08669 3.13086 8.00771 2.89431 8.00949C2.65777 8.01128 2.4315 8.09369 2.26423 8.23899C2.09697 8.38428 2.00209 8.58083 2.00004 8.78629C1.99798 8.99176 2.08891 9.18971 2.25325 9.33751L7.35673 13.7706C7.52591 13.9175 7.75533 14 7.99455 14C8.23377 14 8.4632 13.9175 8.63238 13.7706L13.7359 9.33751C13.905 9.19055 14 8.99127 14 8.78347C14 8.57568 13.905 8.37639 13.7359 8.22944Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7359 2.22944C13.5667 2.08253 13.3373 2 13.098 2C12.8588 2 12.6294 2.08253 12.4602 2.22944L7.99455 6.10846L3.52889 2.22944C3.35874 2.08669 3.13086 2.00771 2.89431 2.00949C2.65777 2.01128 2.4315 2.09369 2.26423 2.23899C2.09697 2.38428 2.00209 2.58083 2.00003 2.78629C1.99798 2.99176 2.08891 3.18971 2.25324 3.33751L7.35673 7.77056C7.52591 7.91747 7.75533 8 7.99455 8C8.23377 8 8.4632 7.91747 8.63238 7.77056L13.7359 3.33751C13.905 3.19055 14 2.99127 14 2.78347C14 2.57568 13.905 2.3764 13.7359 2.22944Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.4a8cb57caee1a9051081a1c00e708088.svg";
export { ForwardRef as ReactComponent };